import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, resolveDirective as _resolveDirective, withDirectives as _withDirectives, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-066c280c"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "office-container" }
const _hoisted_2 = { class: "top animate__fadeInDown wow" }
const _hoisted_3 = { class: "bottom" }
const _hoisted_4 = { class: "imgs" }
const _hoisted_5 = {
  class: "animate__zoomIn wow",
  alt: ""
}
const _hoisted_6 = {
  class: "animate__zoomIn wow",
  alt: ""
}
const _hoisted_7 = {
  class: "animate__zoomIn wow",
  alt: ""
}

import WOW from 'wowjs'
import { onMounted } from "vue"

export default /*#__PURE__*/_defineComponent({
  __name: 'envView',
  setup(__props) {

onMounted(() => {
  new WOW.WOW(
    { live: false }
  ).init()

})

return (_ctx: any,_cache: any) => {
  const _directive_lazy = _resolveDirective("lazy")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("span", null, _toDisplayString(_ctx.$t('envtext')), 1)
    ]),
    _createElementVNode("div", _hoisted_3, [
      _createElementVNode("div", _hoisted_4, [
        _withDirectives(_createElementVNode("img", _hoisted_5, null, 512), [
          [_directive_lazy, require('@/assets/env1.png')]
        ]),
        _withDirectives(_createElementVNode("img", _hoisted_6, null, 512), [
          [_directive_lazy, require('@/assets/env2.png')]
        ]),
        _withDirectives(_createElementVNode("img", _hoisted_7, null, 512), [
          [_directive_lazy, require('@/assets/env3.png')]
        ])
      ])
    ])
  ]))
}
}

})